import { useNavigate } from "react-router-dom";
import FormButton from "../../../Components/Buttons/FormButton";
import PageHeader from "../../../Layout/PageHeader";
import Tabs from "../../../Shared/Tab/Tab";

export default function BomMaintenanceUserDefinedDetailsEdit() {
  const navigate = useNavigate();
  const pageName = `Kitting`;
  const backNavigate = () => {
    return navigate(`/inventory/assembly/kitting/details/{id}`);
  };

  const handleClose = () => {
    backNavigate();
  };

  const tabs = [
    {
      order: 0,
      label: "Basic Information",
      content: (
        <>
        </>
      ),
      visibility: true,
      status: true,
    },
    {
      order: 1,
      label: "Attribute",
      content: (
        <>
        </>
      ),
      visibility: true,
      status: false,
    },
    {
      order: 2,
      label: "Configure Kit",
      content: (
        <>
        </>
      ),
      visibility: true,
      status: false,
    },
    {
      order: 3,
      label: "User defined Field",
      content: (
        <>
        </>
      ),
      visibility: true,
      status: false,
    }
  ];

  return (
    <>
      <PageHeader
        addUrl="/inventory/assembly/kitting/create"
        listUrl="/inventory/assembly/kitting/details/{id}"
        viewType={true}
        isHistoryEnabled={true}
      />
      <h5 className="text-start mt-1 mb-3">{pageName}</h5>
      <Tabs
        tabs={tabs}
        isCheckbox={true}
      />
      <div className="my-2 bg-white rounded py-1 px-2 h-100">

        <div className="checkin-details col-12 bg-white col-12 py-1 py-4 px-5 ">
          <div className="row gap-3">
            <div className="col-5 px-2 mb-3">
              <label className="fw-medium">User Defined Field 01</label>
              <div className="mt-1">
                <input
                  tabIndex={1}
                  autoFocus={true}
                  maxLength={50}
                  type="text"
                  name="name"
                  className={`form-control`}
                  placeholder="Enter"
                />
              </div>
            </div>
            <div className="col-5 px-2 mb-3">
              <label className="fw-medium">User Defined Field 02</label>
              <div className="mt-1">
                <input
                  tabIndex={1}
                  autoFocus={true}
                  maxLength={50}
                  type="text"
                  name="name"
                  className={`form-control`}
                  placeholder="Enter"
                />
              </div>
            </div>
          </div>
          <div className="row gap-3">
            <div className="col-5 px-2 mb-3">
              <label className="fw-medium">User Defined Field 01</label>
              <div className="mt-1">
                <input
                  tabIndex={1}
                  autoFocus={true}
                  maxLength={50}
                  type="text"
                  name="name"
                  className={`form-control`}
                  placeholder="Enter"
                />
              </div>
            </div>
            <div className="col-5 px-2 mb-3">
              <label className="fw-medium">User Defined Field 02</label>
              <div className="mt-1">
                <input
                  tabIndex={1}
                  autoFocus={true}
                  maxLength={50}
                  type="text"
                  name="name"
                  className={`form-control`}
                  placeholder="Enter"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="my-auto bg-white rounded py-3">
        <div className="d-flex flex-row-reverse">
          <FormButton
            tabIndex={25}
            className="sph-btn me-4"
            handleClick={() => handleClose()}
          >
            Submit
          </FormButton>
          <FormButton
            tabIndex={26}
            className="sph-btn sph-shift me-4"
            handleClick={() => handleClose()}
          >
            Cancel
          </FormButton>
        </div>
      </div>
    </>
  );
}
